import { SubjectData } from 'shell/models/person';
import { BirthdayDocument as BirthdayDocumentVM } from 'shell/view-models/birthday-document';
import { DateTime } from 'luxon';

export const transformBirthdayDocument = (person: SubjectData): BirthdayDocumentVM | undefined => {
  const originReturnData: BirthdayDocumentVM | undefined = person?.attoNascita
    ? {
        municipality: person.attoNascita?.comuneRegistrazione
          ? {
              id: person.attoNascita?.comuneRegistrazione?.codiceIstat || '',
              description: person.attoNascita?.comuneRegistrazione?.nomeComune || '',
              province: person.attoNascita?.comuneRegistrazione?.siglaProvinciaIstat || '',
            }
          : undefined,
        istatCode: person.attoNascita?.comuneRegistrazione?.codiceIstat || '',
        province: person.attoNascita?.comuneRegistrazione?.siglaProvinciaIstat || '',
        location: person.attoNascita?.comuneRegistrazione?.descrizioneLocalita || '',
        townHallOffice: person.attoNascita?.ufficioMunicipio || '',
        year: person.attoNascita?.anno || '',
        portion: person.attoNascita?.parte || '',
        serie: person.attoNascita?.serie || '',
        documentNumber: person.attoNascita?.numeroAtto || '',
        volume: person.attoNascita?.volume || '',
        documentDate: person.attoNascita?.dataFormazioneAtto
          ? DateTime.fromISO(person.attoNascita?.dataFormazioneAtto)
          : null,
        transcript: person.attoNascita?.trascritto === '1' ? true : false,
      }
    : undefined;

  return originReturnData;
};
